var module = angular.module('octopusApp.configuration');

module.controller('LicenseIndexController', function($scope, busy, octopusRepository, unsavedChanges, $window) {
  var isLoading = $scope.isLoading = busy.create();
  var isSaving = $scope.isSaving = busy.create();

  $scope.license = null;
  $scope.config = null;
  
  var loadingPromises = [];
  loadingPromises.push(octopusRepository.Licenses.getCurrent().then(function(license) {
      $scope.license = license;
  }));
  loadingPromises.push(octopusRepository.UpgradeConfiguration.get().then(function (config) {
      $scope.config = config;
  }));
  isLoading.promises(loadingPromises).then(function() {
      // Move along, nothing to see here.
  });

  $scope.save = function() {
    var savingPromises = [];
    savingPromises.push(octopusRepository.Licenses.save($scope.license).then(function(saved){ }));
    savingPromises.push(octopusRepository.UpgradeConfiguration.modify($scope.config).then(function(saved){ }));
    isSaving.promises(savingPromises).then(function() {
        // Force a window reload as these config settings affect the top-menu area of the Octopus portal UI.
        unsavedChanges.saved();
        $window.location.reload();
    });
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/license/controllers/license_index_controller.js
// module id = 392
// module chunks = 1